import { FormField } from 'ui/form/form-field';

import { ObjectFieldProps } from 'ui/form/fields';
import { formData } from '../child-field';
import {
  getErrorsFromChildren,
  getFieldValues,
  renderChildren
} from 'ui/form/utils';
interface ObjectFieldState {}

@formData
export default class ObjectField extends FormField<ObjectFieldProps, ObjectFieldState> {
  static get defaultValue() {
    return {};
  }

  static getErrors(props: ObjectFieldProps, formData): string | false {
    return getErrorsFromChildren(props, formData);
  }
  
  fields: { [string]: FormField } = {};
  touched: { [string]: boolean } = {};
  state = {};
  formData = {};

  validate(onlyTouched: boolean) {
    let valid = true;
    for (let fieldKey in this.fields) {
      if ((!onlyTouched || this.touched[fieldKey]) && this.fields[fieldKey].validate) {
        valid &= this.fields[fieldKey].validate(onlyTouched);
      }
    }
    
    console.log('IS VALID', valid);
    return valid;
  }

  getValue() {
    return getFieldValues(this.fields);
  }

  handleChange = (name: string, fieldValue: any) => {
    this.touched[name] = true;
    this.props.onChange({
      ...this.getValue(),
      [name]: fieldValue
    });
  };

  handleRef = (name, ref: FormField) => {
    // If field uses storeConnect we need to get ref.ref
    if (ref) this.fields[name] = ref.ref || ref;
    else delete this.fields[name];
  };
  
  render() {
    const { children } = this.props;
    const childList = renderChildren(children, {
        handleChange: this.handleChange,
        handleRef: this.handleRef,
        props: this.props
      });
    
    return childList;
  }
}
